import { instance } from 'utils/api';

export type ConfigRow = {
  id: number;
  type: string;
  img?: string | null;
  // jsonb passthrough: page-keyed content, e.g. body[page].desktop[lang].content
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: Record<string, any> | null;
};

// GET /config/:type — public, bare row (404 when the type has no row)
export const fetchConfigByType = async (
  type: string
): Promise<ConfigRow | null> => {
  const res = await instance.get<ConfigRow>(`config/${type}`);

  return res.data ?? null;
};
